<template>
  <div id="overlay" v-if="visible" @click.self="close">
    <div id="info" class="p-4 shadow">
      <button class="btn btn-reset p-0 float-right text-lg" @click="close">
        <Close class="svg-fill-dark svg-24" />
      </button>
      <h2 class="text-left">{{ translations.title }}</h2>
      <table class="table text-left mb-0 table-responsive">
        <thead>
          <tr>
            <th class="border-0">{{ translations.vendor }}</th>
            <th class="border-0">{{ translations.price }}</th>
            <th class="border-0">{{ translations.shipping }}</th>
            <th class="border-0"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in products">
            <td>{{ product["vendor_name"] }}</td>
            <td>{{ product["price"] }}</td>
            <td class="text-nowrap">
              {{ product["shipping"] }}
              <br/>
              <small v-if="product['package_delivery_hint']">
                {{ translations.package_delivery_hint }}
              </small>
            </td>
            <td class="text-right text-nowrap">
              <a class="btn btn-primary btn-sm" :href="product['path']">{{ translations.visit }}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Close from "../../../icons/atalanda/close.svg";

export default {
  name: "OtherVendorsModal",
  components: { Close },
  props: {
    products: {
      required: true,
      type: Array
    },
    translations: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      visible: "productShow/showOtherVendorsModal",
    }),
  },
  methods: {
    ...mapActions({
      showOtherVendorsModal: "productShow/showOtherVendorsModal"
    }),
    close() {
      this.showOtherVendorsModal(false);
    }
  }
};
</script>

<style scoped>
  #overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    display: grid;
    place-items: center center;

    /* edge */
    justify-content: center;
    align-items: center;

    background: rgba(0, 0, 0, 0.5);
  }

  /* ie */
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
     #overlay {
       background: transparent;
       filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000,endColorstr=#99000000);
     }
  }

  /* edge */
  @supports (-ms-accelerator:true) {
    #overlay {
      background: transparent;
      filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000,endColorstr=#99000000);
    }
  }

  #info {
    width: 100%;
    max-width: 750px;
    background: white;
    text-align: center;
  }
</style>
